import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import ConfigureClinicianFilters from './ConfigureClinicianFilters';
import LoadingPageText from '../../common/Loading/LoadingPageText';

import { useFetchConfigureClinician } from '../../../actions/areas/admin/fetchHooks/fetchConfigureClinician';
import { tableSettings } from './ConfigureClinicianTableSettings';
import { eventHandlers } from './configureClinicianHandler';

export default function ConfigureClinicianPage() {
  document.title = 'Configure Clinician';

  const [state, setState] = useState({
    startingPostingList: {},
    forceReload: false,
    cliniciansBySurname: '',
    orgUnitId: 0,
    currentPage: 1,
    pageSize: 15,
    sortColumn: 'Surname',
    sortDirection: 'asc',
  });
  const getModel = {
    forceReload: state.forceReload,
    cliniciansBySurname: state.cliniciansBySurname,
    orgUnitId: state.orgUnitId,
    currentPage: state.currentPage,
    pageSize: state.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };
  const { data, isDataLoading, auth, isTableDataLoading } = useFetchConfigureClinician(getModel);
  const configureClinicianEvents = eventHandlers(state, setState, auth);

  const settings = tableSettings({
    startingPostingList: state.startingPostingList,
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: configureClinicianEvents,
    isTableDataLoading,
  });

  const renderDataOrLoadingMessage = () => {
    return isDataLoading ? (
      <LoadingPageText showHeader={false}>Wait a moment while we gather Clinicians info...</LoadingPageText>
    ) : (
      <div className="page-content-wrapper">
        <MUIDataTable
          title={settings.name}
          data={data.items}
          columns={settings.columns}
          options={settings.options}
          className="configure-cilician-table"
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <ConfigureClinicianFilters onSubmit={configureClinicianEvents.onFiltersChange} />
      {renderDataOrLoadingMessage()}
    </React.Fragment>
  );
}
